import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNkStrings } from '../i18n/index.js';
import { cx } from '../internal/utils.js';
import { Icon } from '../internal/icons.js';
/** `mm:ss` / `h:mm:ss`; negative or non-finite input renders `00:00`. */
export function formatElapsed(seconds) {
    const total = typeof seconds === 'number' && Number.isFinite(seconds) && seconds > 0
        ? Math.floor(seconds)
        : 0;
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const remaining = total % 60;
    const pad = (value) => String(value).padStart(2, '0');
    return hours > 0
        ? `${hours}:${pad(minutes)}:${pad(remaining)}`
        : `${pad(minutes)}:${pad(remaining)}`;
}
/**
 * Recording / streaming indicator ("录制中" badge).
 *
 * Parity with AgoraMeeting's recording banner: a pulsing dot, the mode word and the elapsed time.
 * It is a `role="status"` live region, so assistive tech announces "recording started" once instead
 * of on every timer tick (the timer lives in `aria-hidden` text).
 */
export function RecordingIndicator({ active, mode = 'recording', elapsedSeconds = null, label, hideElapsed = false, compact = false, className, }) {
    const { t } = useNkStrings();
    if (!active)
        return null;
    const modeLabel = mode === 'streaming' ? t('recording.live') : t('recording.recording');
    const text = label ?? (mode === 'streaming' ? t('recording.liveBadge') : t('recording.recBadge'));
    const elapsed = hideElapsed ? null : formatElapsed(elapsedSeconds);
    const ariaLabel = `${t('recording.inProgress', { mode: modeLabel })}${elapsed ? `, ${elapsed}` : ''}`;
    return (_jsxs("span", { className: cx('nk-rec', compact && 'nk-rec--compact', mode === 'streaming' && 'nk-rec--live', className), role: "status", "aria-live": "polite", "aria-label": ariaLabel, "data-recording-mode": mode, children: [_jsx(Icon, { name: "record", size: 14, className: "nk-rec__dot" }), _jsx("span", { className: "nk-rec__label", "aria-hidden": "true", children: text }), elapsed ? (_jsx("span", { className: "nk-rec__time", "aria-hidden": "true", "data-testid": "recording-elapsed", children: elapsed })) : null] }));
}
//# sourceMappingURL=RecordingIndicator.js.map